import React, {useState, useEffect, useRef} from "react";
import axios from "axios";
import ReactQuill, {Quill} from 'react-quill'
import ImageResize from 'quill-image-resize-module-react';
import {InputText} from "primereact/inputtext";
import {Toast} from 'primereact/toast';
import {Calendar} from 'primereact/calendar';
import {Dropdown} from 'primereact/dropdown';
import {Button} from "primereact/button";
import "../../css/editor.css"
import {Card} from 'primereact/card';
import {Fieldset} from 'primereact/fieldset';
import {Slider} from 'primereact/slider';
import {Toolbar} from 'primereact/toolbar';
import {FileUpload} from 'primereact/fileupload';
import {Dialog} from "primereact/dialog";
import {TabView, TabPanel} from 'primereact/tabview';
import {DataView} from "primereact/dataview";
import TextImages from "../../assets/flags/text2_img_2.png"
import DocxImages from "../../assets/flags/docx_img_2.png"
import Test1 from "../../assets/flags/test.png"
import Test2 from "../../assets/flags/test2.png"
import Test3 from "../../assets/flags/test3.png"
import PdfImages from "../../assets/flags/pdf_img2.png"
import {Checkbox} from 'primereact/checkbox';
import {none} from "html-webpack-plugin/lib/chunksorter";
import {Message} from 'primereact/message';
import {Tag} from "primereact/tag";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";

function MyEditor() {
}

const fontSizeArr = ['12px', '14px', '16px', '20px', '24px', '32px', '42px', '54px', '68px', '84px', '98px'];
var Size = Quill.import('attributors/style/size');
Size.whitelist = ['small', false, 'large', 'huge'];
Quill.register(Size, true);

Quill.register('modules/imageResize', ImageResize);

MyEditor.modules = {
    toolbar: [
        [{header: '1'}, {header: '2'}, {font: []}],
        [{size: ['small', false, 'large', 'huge']}],
        [{align: ''}, {align: 'center'}, {align: 'right'}, {align: 'justify'}],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            {list: 'ordered'},
            {list: 'bullet'},
            {indent: '-1'},
            {indent: '+1'}
        ],
        ['link'],
        ['clean']
    ],
    clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false
    },
    imageResize: {
        parchment: Quill.import('parchment'),
        modules: ['Resize', 'DisplaySize']
    }

}

MyEditor.formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
    "video",
    "code-block",
    "align",

];

const CmsContentPage = props => {
    ///////////content değişkenleri////////////
    const toast = useRef(null);
    const [contPriority, setContPriority] = useState(0);
    const [contTitle, setContTitle] = useState('');
    const [contText, setContText] = useState('');
    const [contKeywords, setContKeywords] = useState('');
    const [contProperties, setContProperties] = useState('');
    const [categoryID, setCategoryID] = useState(null);
    const [contId, setContId] = useState(null);
    const [typeID, setTypeID] = useState(null);
    const [contStartTime, setContStartTime] = useState(null);
    const [contFinishTime, setContFinishTime] = useState(null);
    const [contUpdateTime, setContUpdateTime] = useState(null);
    const [contParticipation, setContParticipation] = useState(false);
    const [typeList, setTypeList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);

    ///////////file değişkenleri////////////

    const [fileTypeID, setFileTypeID] = useState(null);
    const [moduleID, setmoduleID] = useState(null);
    const [cmflID, setCmflID] = useState('');
    const [cmflFileName, setCmflFileName] = useState('');
    const [fileType, setFileType] = useState('');
    const [fileUrl, setFileUrl] = useState('');
    const [fileDialog, setFileDialog] = useState(false);
    const [filedialogImage, setFiledialogImage] = useState(false);
    const [cmflFilePath, setCmflFilePath] = useState([]);
    const [cmflDetail, setCmflDetail] = useState('');
    const [fileTypeList, setFileTypeList] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [moduleList, setModuleList] = useState([]);
    const [cmflDialog, setCmflDialog] = useState(false);
    const submitBtnLabel = useState(localStorage.getItem('cms_publish') ? "Yayımla" : "Onaya Gönder");
    const contentAddRole = !!localStorage.getItem('cms_add');
    const [cities, setCities] = useState([]);
    const [activeIndex1, setActiveIndex1] = useState(0);
    const [buttonDisplay, setButtonDisplay] = useState('block');
    const [cipDeleteDialog, setCipDeleteDialog] = useState(false);
    const [infoDialog, setInfoDialog] = useState(false);
    const [introId, setIntroId] = useState(null);
    const [headlineChecked, setHeadlineChecked] = useState(false);


    useEffect(() => {
        getFileTypeList();
        getTypeList();
        getModuleList();
        getContentFile();


        const cont_id = parseInt(props.match.params['cont_id']);
        if (Number.isInteger(cont_id)) {
            setContId(cont_id);
            getContent(cont_id)
        }
    }, []);

    useEffect(() => {

            if (contText.length > 0) {
                setButtonDisplay('block')


                if ((props.match.params['cont_id']) === undefined) {

                    postDraft()
                }
            } else {
                setButtonDisplay('none')

            }

        }
        ,
        [contText, contPriority, contTitle, cmflFilePath]
    );

    let all_table_header_tabpanel = (

        <div className="p-mt-1">
            <h6><b>Dosya Ekle </b></h6>

        </div>


    );
    let all_table_header_tabpanel2 = (

        <div className="p-mt-1">
            <h6><b>Eklenen Medyalar</b></h6>


        </div>


    );


    const ModuleOptionItems = moduleList.map((item) => (
        {"label": item.md_name, "value": item.md_id}
    ))

    const FiletypeOptionItems = fileTypeList.map((item) => (
        {"label": item.cft_name, "value": item.cft_id}
    ))


    const typeOptionItems = typeList.map((item) => (
        {"label": item.ctyp_name, "value": item.ctyp_id}
    ))


    const categoryOptionItems = categoryList.map((item2) => (
        {"label": item2.ccc_name, "value": item2.ccc_id}
    ))

    const rightContents = (
        <React.Fragment>

            <Button label={submitBtnLabel} icon="pi pi-check" className="p-button-success" onClick={() => submit()}
                    style={{height: '40px', width: '200px'}}/>

        </React.Fragment>
    );
    const leftContents = (
        <React.Fragment>
            <Button label="Taslak olarak kaydet" icon="pi pi-save" className="p-mr-2" onClick={() => submitDraft()}
                    style={{height: '40px', width: '250px'}}/>

        </React.Fragment>
    );


    const selectContentPost = (cont_id) => {
        const url = "/content/" + cont_id + "/";
        window.location.hash = url
    }

    const postDraft = (cont_id) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        let content_id = null;
        const obj = {
            contID: cont_id,
            contProperties: null,
            contTitle: contTitle,
            contText: contText,
            contKeywords: contKeywords,
            contPriority: 0,
            contStartTime: contStartTime,
            contFinishTime: contFinishTime,
            contDraft: true,
            contActive: true,
            typeID: typeID,
            categoryID: categoryID,
            contParticipation: contParticipation,
            moduleID: moduleID
        };
        if (Number.isInteger(contId)) {
            axios.put('/api/cms_content' + `/${cont_id}/`, obj, {"headers": headers})
                .then(res => {


                });
        } else {
            axios.post('/api/cms_content/', obj, {"headers": headers})
                .then(res => {


                    content_id = res.data.content_id
                    if (res.data.result) {
                        setContId(content_id)
                        selectContentPost(content_id)
                    } else {
                        showError(res.data.message)
                    }
                })
        }
    }

    const getContent = (cont_id) => {


        getContentFile(cont_id);


        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/cms_content' + `/${cont_id}/`, {"headers": headers})
            .then(res => {
                const data = res.data.result_data
                for (let i = 0; i < data.length; i++) {
                    const file = data[i];
                    setContKeywords(file.cont_keywords)
                    setContText(file.cont_text)
                    setContStartTime(new Date(file.cont_pstarttime))
                    setContFinishTime(new Date(file.cont_pfinishtime))
                    setContParticipation(file.cont_flag_participation)
                    setContTitle(file.cont_title)
                    setContPriority(file.cont_priority)
                    setTypeID(file.ctyp_id)
                    setCategoryID(file.ccc_id)
                    setmoduleID(file.md_id)
                    setContProperties(file.cont_properties)
                }
            })
    }

    const getContentFile = (cont_id) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/content_files' + `/${cont_id}/`, {"headers": headers})
            .then(res => {
                const res_file = res.data.result_file
                if (res_file !== null && res_file !== undefined) {
                    setFileList(res_file)
                    res.data.result_file.map((item) => {

                        if (item.cft_id === 2) {
                            setHeadlineChecked(true)

                        }
                    })
                }
            })

    }

    const getFileTypeList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/content/type/file/', {"headers": headers})
            .then(res => {
                setFileTypeList(res.data)
            })

    }

    const getModuleList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/content/module/list/', {"headers": headers})
            .then(res => {

                setModuleList(res.data)
                console.log(res.data, "cms-content")
            })
    }

    const getTypeList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('api/content/type/list/', {"headers": headers})
            .then(res => {
                setTypeList(res.data)
            })
    }

    const handleBody = e => {
        setContText(e);
    };

    const submitContentFile = () => {
        if (fileTypeID !== null) {

            const obj = {
                cmflID: cmflID,
                cmflFileName: cmflFileName,
                cmflFilePath: cmflFilePath,
                cmflDetail: cmflDetail,
                ctyp_id: typeID,
                fileTypeID: fileTypeID,
                cont_id: parseInt(props.match.params['cont_id'])
            };

            let headers = {"Content-Type": "application/json"};
            let token = localStorage.getItem("token");
            if (token) {
                headers["Authorization"] = `Token ${token}`;
                const body = JSON.stringify(obj);
                fetch("/contents/file_upload/content", {headers, method: "POST", body})

                    .then(res => {
                        if (res.status < 500) {
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            getContentFile(contId)
                            if (fileTypeID === 2) {
                                setHeadlineChecked(true)
                                setFileTypeID('')
                            }


                            const data = res.data;
                            if (data.result) {
                                setFileTypeID('')

                                showSuccess(data.message);

                                setCmflFileName('')
                                setCmflFilePath([])
                                setCmflDetail('')
                                setActiveIndex1(1)


                            } else {
                                showError(data.message);
                            }
                        } else if (res.status === 401 || res.status === 403) {
                            throw res.data;
                        }
                    })


            }
        } else {
            showError("Dosya seçimi yapmadan ekleme işlemi gerçekleştirilemezsiniz!");
        }

    }

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const submit = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        if (typeID != null && moduleID != null && contText.length > 0 && contTitle.length > 0) {
            if (submitBtnLabel[0] === "Yayımla") {
                const obj = {
                    contID: contId,
                    contTitle: contTitle,
                    contText: contText,
                    contKeywords: contKeywords,
                    contPriority: contPriority,
                    contStartTime: contStartTime,
                    contFinishTime: contFinishTime,
                    typeID: typeID,
                    categoryID: categoryID,
                    contDraft: false,
                    contActive: true,
                    contParticipation: contParticipation,
                    moduleID: moduleID,
                    contProperties: contProperties


                };
                if (headlineChecked === true) {


                    if (contId) {
                        axios.put('/api/cms_content' + `/${contId}/`, obj, {"headers": headers})
                            .then(res => {
                                const data = res.data
                                if (data.result) {
                                    window.location.hash = '/contents'

                                    showSuccess(data.message);
                                } else {
                                    showError(data.message);
                                }

                            })
                    } else {

                        axios.post('/api/cms_content/', obj, {"headers": headers})
                            .then(res => {
                                const data = res.data
                                if (data.result) {
                                    window.location.hash = '/contents'
                                    showSuccess(data.message);
                                } else {
                                    showError(data.message);
                                }
                            })
                    }
                } else {
                    toast.current.show({severity: 'error', summary: 'Manşet fotoğrafı eklenmeden içerik eklenemez!'});


                }
            } else {
                const obj = {
                    contID: contId,
                    contProperties: "",
                    contTitle: contTitle,
                    contText: contText,
                    contKeywords: contKeywords,
                    contPriority: contPriority,
                    contStartTime: contStartTime,
                    contFinishTime: contFinishTime,
                    typeID: typeID,
                    categoryID: categoryID,
                    contDraft: false,
                    contActive: false,
                    contParticipation: contParticipation,
                    moduleID: moduleID


                };
                if (contId) {

                    axios.put('/api/cms_content' + `/${contId}/`, obj, {"headers": headers})
                        .then(res => {
                            const data = res.data

                            if (data.result) {

                                window.location.hash = '/contents'

                                showSuccess(data.message);
                            } else {
                                showError(data.message);
                            }

                        })
                } else {


                    axios.post('/api/cms_content/', obj, {"headers": headers})
                        .then(res => {
                            const data = res.data

                            if (data.result) {

                                window.location.hash = '/contents'

                                showSuccess(data.message);
                            } else {
                                showError(data.message);
                            }
                        })
                }
                //
                // setContText('')
                // setContTitle('')
            }
        } else {
            toast.current.show({
                severity: 'error',
                summary: 'Form alanları doldurulmadan içerik yayımlanamaz,sadece taslak olarak kaydedilebilir!'
            });
        }

    }


    const submitDraft = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        const obj = {
            contID: contId,
            contProperties: "",
            contTitle: contTitle,
            contText: contText,
            contKeywords: contKeywords,
            contPriority: contPriority,
            contStartTime: contStartTime,
            contFinishTime: contFinishTime,
            contUpdateTime: contUpdateTime,
            contDraft: true,
            contActive: true,
            typeID: typeID,
            categoryID: categoryID,
            contParticipation: contParticipation,
            moduleID: moduleID


        };
        if (contId) {
            axios.put('/api/cms_content' + `/${contId}/`, obj, {"headers": headers})
                .then(res => {

                    window.location = '#/contents'

                });
        } else {


            axios.post('/api/cms_content/', obj, {"headers": headers})

                .then(res => {


                })


        }

        // setContText('')
        // setContTitle('')


    }

    const handleImageChange = (e) => {

        let files = e.files;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                cmflFilePath.push(reader.result)
            };

        }
    }

    const editDialog = (fileType, fileUrl) => {
        setFileDialog(true)
        setFileType(fileType)
        setFileUrl(fileUrl)


    }
    const editDialog2 = (fileType, fileUrl) => {
        setFiledialogImage(true)
        setFileType(fileType)
        setFileUrl(fileUrl)


    }

    const onCityChange = (e) => {
        const test = contText
        let selectedCities = [...cities];

        if (e.value.file_type === "image") {
            setContText(test + "<br></br>" + "<img  src=" + e.value.cmfl_filepath + "></img>")

        } else if (e.value.file_type === "video") {
            setContText(test[0] + "<br></br>" + "<iframe className=\"ql-video\" frameBorder=\"0\" allowFullScreen=\"true\"\n" +
                "                                src=" + e.value.cmfl_filepath + "></iframe>")

        }

        if (e.checked)
            selectedCities.push(e.value);
        else
            selectedCities.splice(selectedCities.indexOf(e.value), 1);

        setCities(selectedCities);

    }
    const renderFooter = () => {
        return (
            <div>

                <Button label="Hayır" icon="pi pi-times" onClick={() => setCipDeleteDialog(false)}
                        className="p-button-text"/>
                <Button label="Evet" icon="pi pi-check" onClick={() => deleteFile(introId)} autoFocus/>
            </div>
        );
    }
    const deleteRow = (cmflID) => {


        setCipDeleteDialog(true)
        setIntroId(cmflID)
    }
    const deleteFile = (cmflID) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.delete('/contents/file_upload' + `/${cmflID}/`, {"headers": headers})
            .then(res => {
                const data = res.data
                if (data.result) {

                    showSuccess(data.message);
                } else {
                    showError(data.message);
                }
                getContentFile(contId);

                setCipDeleteDialog(false)
                setIntroId(null)

            });
    };

    const footer = (item) => {
        // //console.log(item['cmfl_id'], "****")
        return (
            <div>
                <Button icon="pi pi-search"
                        onClick={() => editDialog2("image/png", item.cmfl_filepath)}
                        className="p-button-rounded p-button-success p-mr-4"/>
                <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-outlined"
                        onClick={() => deleteRow(item['cmfl_id'])}
                />
            </div>
        )
    }
    const footer2 = (item) => {
        return (
            <div>
                <Checkbox value={item} onChange={onCityChange}
                          checked={cities.indexOf(item) !== -1}
                          style={{display: item.cft_id === 2 || item.cft_id === 3 ? 'none' : 'block'}}/>
            </div>
        )
    }
    const footer3 = (item) => {
        if (item.cft_id === 2) {
            return (
                <div>
                    <Tag severity="success" value="Manşet Fotoğrafı" className="p-md-5"
                    >

                    </Tag>
                </div>
            )
        } else if (item.cft_id === 3) {
            return (
                <div>
                    <Tag severity="primary" value="Galeri" className="p-md-5"
                    >

                    </Tag>
                </div>
            )
        }
    }
    const footer4 = (item) => {
        return (
            <div>
                <Button icon="pi pi-caret-right"
                        onClick={() => editDialog("video/mp4", item.cmfl_filepath)}
                        className="p-button-rounded p-button-success p-mr-4"/>
                <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-outlined"
                        onClick={() => deleteRow(item['cmfl_id'])}/>
            </div>
        )
    }
    const footer5 = (item) => {
        return (
            <div>
                <Button icon="pi pi-search"
                        onClick={() => editDialog("application/pdf", item.cmfl_filepath)}
                        className="p-button-rounded p-button-success p-mr-4"/>
                <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-outlined"
                        onClick={() => deleteRow(item['cmfl_id'])}/>
            </div>
        )
    }
    const footer6 = (item) => {
        return (
            <div>
                {/*<Button icon="pi pi-search"*/}
                {/*        onClick={() => editDialog("application/vnd.openxmlformats-officedocument.wordprocessingml.document", item.cmfl_filepath)}*/}
                {/*        className="p-button-rounded p-button-success p-mr-4"/>*/}

                <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-outlined"
                        onClick={() => deleteRow(item['cmfl_id'])}/>
            </div>
        )
    }
    const cmflDialogOnHide = () => {
        setCmflDialog(false)
        setFileTypeID('')
    }


    const cardItemsAllContent = (item) => {


        if (item.file_type === "image") {


            return (

                <Card title={footer2(item)} subTitle={footer3(item)} style={{width: '20rem', marginBottom: '2em'}}
                      footer={footer(item)}
                      className="p-mr-5 p-mb-5 p-md-2">

                    <img src={item.cmfl_filepath} className="p-md-12" style={{width: '200px', height: '200px'}}/>

                </Card>


            )

        } else if (item.file_type === "video") {

            return (
                <Card title={footer2(item)} style={{width: '25em'}} footer={footer4(item)}
                      className="p-mr-5 p-mb-5 p-md-2">
                    <video style={{maxHeight: '12em'}} className="p-mt-3" autoPlay={false} controls muted>
                        <source src={item.cmfl_filepath} type="video/mp4" style={{width: '200%'}}/>

                    </video>

                </Card>
            )


        } else if (item.file_type === "pdf") {

            return (
                <Card subTitle={footer3(item)} style={{width: '25em'}} footer={footer5(item)}
                      className="p-mr-5 p-mb-5 p-md-2">
                    <img src={PdfImages}
                         style={{width: '60%', height: '12vw'}}/>

                </Card>


            )


        } else if (item.file_type === "txt") {

            return (

                <Card subTitle={footer3(item)} style={{width: '25em'}} footer={footer5(item)}
                      className="p-mr-5 p-mb-5 p-md-2">
                    <img src={TextImages}
                         style={{width: '60%', height: '12vw'}}/>

                </Card>


            )


        } else if (item.file_type === "docx") {

            return (
                <Card subTitle={footer3(item)} style={{width: '25em'}} footer={footer6(item)}
                      className="p-mr-5 p-mb-5 p-md-2">
                    <img src={DocxImages}
                         style={{width: '60%', height: '12vw'}}/>

                </Card>

            )
        }
    }

    const typeContent = (typeID) => {
        setTypeID(typeID)
        setCategoryID(null)
        getTypetoCategory(typeID)

    }

    let minDate = contStartTime
    let today = new Date();

    const getTypetoCategory = (typeID) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/type_category' + `/${typeID}/`, {"headers": headers})
            .then(res => {
                setCategoryList(res.data.categories)
            })
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return {status: res.status, data};

                    })
                } else {
                    //console.log("Server Error!");
                    throw res;
                }
            })
            .then(res => {
                if (res.status === 200) {
                    setCategoryList(res.data.categories)

                } else if (res.status === 401) {
                    props.loadUser();
                    throw res.data;

                } else if (res.status === 403) {
                    throw res.data;

                }
            })
    }


    if (contentAddRole) {

        return (
            <div className="p-fluid" style={{fontSize: 'large'}}>
                <Toast ref={toast}/>
                <Dialog header="UYARI" visible={cipDeleteDialog}
                        style={{width: '20%'}}
                        footer={renderFooter()}
                        onHide={() => setCipDeleteDialog(false)}>
                    <div className="confirmation-content">
                        <i className="pi pi-trash p-mr-3" style={{fontSize: '2rem'}}/>
                        <span>Dosya Silinecek Emin misiniz?</span>
                    </div>
                </Dialog>


                <Dialog
                    visible={cmflDialog}
                    style={{width: '50vw'}}

                    onHide={cmflDialogOnHide} maximizable>

                    <TabView className="tabview-custom" activeIndex={activeIndex1}
                             onTabChange={(e) => setActiveIndex1(e.index)}>

                        <TabPanel header={all_table_header_tabpanel} classname="p-mr-2">
                            <Card title="Dosya Ekleme">
                                <div className="p-grid p-mt-3">
                                    <div className="p-col-12 p-md-2">
                                        <label htmlFor="input">Dosya Türü</label>
                                        <span style={{color: "red"}}> (*)</span>

                                    </div>
                                    <div className="p-col-12 p-md-10">
                                        <Dropdown
                                            options={FiletypeOptionItems}
                                            onChange={(e) => setFileTypeID(e.target.value)}
                                            value={fileTypeID}
                                            filter={true}
                                            showClear={true}
                                            required={true}
                                            placeholder="Dosya Türünü Seçiniz"/>
                                    </div>

                                    <div className="p-col-12 p-md-2">
                                        <label htmlFor="input">Dosya Adı</label>
                                        <span style={{color: "red"}}> (*)</span>

                                    </div>
                                    <div className="p-col-12 p-md-10">
                                        <InputText
                                            value={cmflFileName}
                                            onChange={(e) => setCmflFileName(e.target.value)}
                                            name="text"
                                            id="text"
                                            minLength={2}
                                            maxLength={100}
                                            placeholder="Dosya Adı Ekle"
                                            keyfilter={/^[^<>=*!]+$/}

                                        />
                                    </div>
                                    <div className="p-col-12 p-md-2">
                                        <label htmlFor="input">Dosya Seçimi</label>
                                        <span style={{color: "red"}}> (*)</span>

                                    </div>
                                    <div className="p-col-12 p-md-10">

                                        {fileTypeID === 1
                                            ?
                                            <FileUpload
                                                accept="application/pdf"
                                                maxFileSize={5000000}

                                                onSelect={handleImageChange}
                                                uploadLabel="Yükle"
                                                chooseLabel="Seç"
                                                cancelLabel="İptal"
                                            />


                                            :
                                            null
                                        }

                                        {fileTypeID === 6
                                            ?
                                            <FileUpload
                                                accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                maxFileSize={5000000}

                                                onSelect={handleImageChange}
                                                uploadLabel="Yükle"
                                                chooseLabel="Seç"
                                                cancelLabel="İptal"
                                            /> :
                                            null}

                                        {fileTypeID === 2 || fileTypeID === 3 || fileTypeID === 5
                                            ?
                                            <FileUpload
                                                multiple
                                                accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"
                                                maxFileSize={5000000}
                                                onSelect={handleImageChange}
                                                uploadLabel="Yükle"
                                                chooseLabel="Seç"
                                                cancelLabel="İptal"

                                            /> :
                                            null}
                                        {fileTypeID === 4
                                            ?
                                            <FileUpload
                                                accept=".mp4" maxFileSize={50000000}
                                                onSelect={handleImageChange}
                                                uploadLabel="Yükle"
                                                chooseLabel="Seç"
                                                cancelLabel="İptal"

                                            /> :
                                            null}


                                    < /div>

                                    <div className="p-col-12 p-md-10" align="center">
                                        <Button label="Ekle" icon="pi pi-check" className="p-button-success"
                                                onClick={() => submitContentFile()}/>
                                    </div>

                                </div>
                            </Card>


                        </TabPanel>
                        <TabPanel header={all_table_header_tabpanel2}>

                            <div className="p-grid p-md-12" align="center">
                                <div className="p-col-12 p-md-12 p-mb-4">
                                    <Message severity="info"
                                             text="Uyarı: Resimleri ve videoları sol üstlerindeki seçim kutucuğuna tıklayarak editöre ekleyebilirsiniz. "/>
                                </div>
                                <div className="p-col-12 p-md-12 p-mb-4" align="center">

                                    <DataView value={fileList} layout={'grid'}
                                              itemTemplate={cardItemsAllContent} paginator rows={2}
                                              emptyMessage="Kayıt Bulunamadı."
                                              style={{display: "table-row"}}

                                    />
                                </div>
                            </div>

                        </TabPanel>


                    </TabView>
                </Dialog>
                <Dialog header="Dosyanız"
                        visible={fileDialog}
                        style={{width: '70%'}}
                        onHide={() => setFileDialog(false)} maximizable>
                    <div>
                        <iframe src={fileUrl} type={fileType} style={{width: '100%', minHeight: '500px'}}/>
                    </div>
                </Dialog>


                <Dialog header="Dosyanız"
                        visible={filedialogImage}
                        style={{width: '70%'}}
                        onHide={() => setFiledialogImage(false)} maximizable>
                    <img src={fileUrl} style={{width: '100%', minHeight: '300px'}}/>


                </Dialog>


                <Card>

                    <div className="p-grid">
                        <div className="p-col-12 p-xl-9">
                            <div className="p-col-12 p-md-12">
                                <div className="p-col-12 p-md-12">


                                    <Fieldset legend="Başlık ve Metin Ekle" toggleable>


                                        <div className="p-col-12 p-md-12">

                                            <InputText
                                                value={contTitle}
                                                onChange={(e) => setContTitle(e.target.value)}
                                                name="text"
                                                id="text"
                                                minLength={2}
                                                maxLength={120}
                                                placeholder="Başlık ekle"
                                                style={{background: '#f3f4f7'}}
                                                className="p-inputtext-lg p-d-block"
                                                keyfilter={/^[^<>=*!]+$/}

                                            />

                                        </div>

                                        <div className="p-col-12 p-md-3" style={{display: buttonDisplay}}>

                                            <div className="p-col-12 p-md-12">
                                                <Message severity="info"
                                                         text="Uyarı: Aşağıdaki butonu kullanarak medya ve dosya ekleyebilirsiniz"/>
                                            </div>
                                            <Button label="Medya & Dosya Ekle" icon="pi pi-camera"
                                                    onClick={() => setCmflDialog(true)}

                                                    className="p-mb-3 p-mt-3 p-ml-2 p-button-label"/>


                                        </div>


                                        {/*<div>*/}
                                        {/*    <img*/}

                                        {/*        style={{*/}
                                        {/*            height: '8vw',*/}

                                        {/*        }}*/}

                                        {/*        src={headlineUrl}*/}

                                        {/*        // onClick={(e) => setContText(test[0] + "<img  src=" + item.cmfl_filepath + "/>")}*/}
                                        {/*    />*/}
                                        {/*</div>*/}


                                        <div className="p-col-12 p-md-12" align="left">


                                            <ReactQuill
                                                style={{
                                                    maxHeight: '600px',
                                                    overflowY: 'scroll',
                                                    overflowX: 'block'
                                                }}
                                                placeholder="Birşeyler yaz"
                                                modules={MyEditor.modules}
                                                formats={MyEditor.formats}
                                                onChange={handleBody}
                                                value={contText}
                                                theme="snow"
                                            >

                                            </ReactQuill>


                                        </div>

                                    </Fieldset>

                                </div>


                            </div>


                        </div>

                        <div className="p-col-12 p-xl-3">


                            <div className="p-col-12 p-md-12">
                                <div className="p-mb-4">
                                    <div className="p-col-12 p-md-12">
                                        <Fieldset legend="Portal-Modül Seçimi" className="p-text-bold"
                                                  toggleable>

                                            <div className="p-col-12 p-md-12">

                                                <Dropdown
                                                    options={ModuleOptionItems}
                                                    onChange={(e) => setmoduleID(e.target.value)}
                                                    value={moduleID}
                                                    filter={true}
                                                    showClear={true}
                                                    required={true}
                                                    placeholder="Portal-Modül Seçiniz"
                                                    emptyMessage="Kayıt Bulunamadı"
                                                />
                                            </div>
                                        </Fieldset>


                                    </div>
                                </div>
                                <Fieldset legend="İçerik Türü ve Kategori Seçimi" toggleable
                                          className="p-text-bold">


                                    <div className="p-col-12 p-md-12">

                                        <Dropdown
                                            options={typeOptionItems}
                                            onChange={(e) => typeContent(e.target.value)}
                                            value={typeID}
                                            filter={true}
                                            showClear={true}
                                            required={true}
                                            placeholder="İçerik Türünü Seçiniz"
                                            emptyMessage="Kayıt Bulunamadı"

                                        />
                                    </div>
                                    <div className="p-col-12 p-md-12">
                                        <Dropdown
                                            options={categoryOptionItems}
                                            onChange={(e) => setCategoryID(e.target.value)}
                                            value={categoryID}
                                            filter={true}
                                            showClear={true}
                                            required={true}
                                            placeholder="Kategori Seçiniz"
                                            emptyMessage="Kayıt Bulunamadı"

                                        />
                                    </div>
                                </Fieldset>


                            </div>

                            <div className="p-mt-4">
                                <div className="p-col-12 p-md-12">
                                    <Fieldset legend="Anahtar Kelime Ekle" toggleable
                                              className="p-text-bold">

                                        <div className="p-col-12 p-md-12">
                                            <InputText
                                                placeholder="Anahtar Kelime Giriniz"
                                                value={contKeywords}
                                                onChange={(e) => setContKeywords(e.target.value)}
                                                name="keywords"
                                                id="keywords"
                                                minLength={2}
                                                maxLength={35}
                                                keyfilter={/^[^<>=*!]+$/}

                                                style={{background: '#f3f4f7'}}
                                                required/>

                                        </div>
                                    </Fieldset>


                                </div>
                            </div>
                            <div className="p-mt-4">
                                <div className="p-col-12 p-md-12">
                                    <Fieldset legend="Öncelik Belirle" toggleable className="p-text-bold"
                                    >
                                        <div className="p-col-12 p-md-12">

                                            <h6><b>Öncelik belirten bir sayı giriniz!</b></h6>
                                            <div className="slider-demo">
                                                <InputText value={contPriority} keyfilter="int"
                                                           onChange={(e) => setContPriority(e.target.value)}
                                                           className="p-inputtext-lg p-d-block"
                                                           style={{background: '#f3f4f7'}}/>
                                                <Slider value={contPriority}
                                                        onChange={(e) => setContPriority(e.value)}/>


                                            </div>


                                        </div>
                                    </Fieldset>


                                </div>
                            </div>
                            <div>
                                <div className="p-mt-6">
                                    <div className="p-col-12 p-sm-4 p-md-12 p-lg-12 p-xl-12">

                                        <Fieldset legend="Başlangıç-Bitiş Tarihleri" toggleable
                                                  className="p-text-bold"
                                        >
                                            <div className="p-col-12 p-md-12">
                                                <Calendar
                                                    showIcon
                                                    placeholder="Başlangıç Tarihi"
                                                    hideOnDateTimeSelect={true}
                                                    minDate={today}
                                                    dateFormat="dd/mm/yy"
                                                    locale="tr"
                                                    id="time24"
                                                    value={contStartTime}
                                                    onChange={(e) => setContStartTime(e.value)} showTime
                                                    showSeconds
                                                />

                                            </div>
                                            <div className="p-col-12 p-md-12">
                                                <Calendar
                                                    showIcon
                                                    placeholder="Bitiş Tarihi"
                                                    hideOnDateTimeSelect={true}
                                                    minDate={minDate}
                                                    dateFormat="dd/mm/yy"
                                                    locale="tr"
                                                    id="time24"
                                                    value={contFinishTime}
                                                    onChange={(e) => setContFinishTime(e.value)} showTime
                                                    showSeconds
                                                />

                                            </div>

                                        </Fieldset>
                                    </div>

                                </div>

                                <div className="p-mt-4">
                                    <div className="p-col-12 p-md-12">
                                        <Fieldset legend="Canlı Yayın Ekle" toggleable
                                                  className="p-text-bold">
                                            <div className="p-col-12 p-md-12">
                                                <Dialog header="Bilgi" visible={infoDialog} style={{width: '70vw'}}
                                                        onHide={() => setInfoDialog(false)}>
                                                    <img src={Test1}
                                                         style={{width: '150%'}}
                                                    /> <br/>
                                                    <img src={Test2}
                                                         style={{width: '150%'}}

                                                    />
                                                    <br/>
                                                    <img src={Test3}
                                                         style={{width: '100%'}}

                                                    />
                                                    <br/>
                                                </Dialog>
                                                <Button icon="pi pi-info" className="p-button-rounded p-button p-mb-2"
                                                        onClick={() => setInfoDialog(true)}/>
                                                <InputText
                                                    placeholder="Canlı Yayın Linkini Giriniz"
                                                    value={contProperties}
                                                    onChange={(e) => setContProperties(e.target.value)}
                                                    name="keywords"
                                                    id="keywords"
                                                    minLength={2}
                                                    maxLength={200}
                                                    style={{background: '#f3f4f7'}}
                                                />
                                            </div>
                                        </Fieldset>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>
                    <div className="p-col-12 p-xl-12">
                        <Toolbar right={rightContents} left={leftContents}/>
                    </div>
                </Card>
            </div>

        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
        return {
            putMethod: (data, url, type) => {
                return dispatch(management.putMethod(data, url, type));
            },
            postMethod: (data, url, type) => {
                return dispatch(management.postMethod(data, url, type));
            },
            deleteMethod: (data, url, type) => {
                return dispatch(management.deleteMethod(data, url, type));
            },
            logout: () => dispatch(auth.logout()),
            loadUser: () => {
                return dispatch(auth.loadUser());
            },

        }
    }
;

export default connect(mapStateToProps, mapDispatchToProps)(CmsContentPage);




// WEBPACK FOOTER //
// ./src/pages/cmsmanagement/CmsContent.jsx